import GetAppIcon from '@mui/icons-material/GetApp';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid2';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import { useContext, useEffect } from 'react';
import SnackbarContext from '@/contexts/SnackbarContext';
import { useGlobalDownloads } from '@/pages/GlobalDownload/hooks/useGlobalDownloads';
import { downloadHistoryStore } from '@/stores/downloadHistoryStore';
import { DownloadTypeEnum } from '@/types/GraphqlSchema';

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.sizes.fullPage,
  },
  globalDownloadsAppBar: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'white',
    zIndex: 1,
  },
  globalDownloadsHeader: {
    color: '#2a2e49',
    padding: '12px 36px',
    [theme.breakpoints.down('lg')]: {
      padding: '12px 10px',
    },
  },
  globalDownloadsDescription: {
    flexGrow: 1,
    overflow: 'auto',
    padding: theme.spacing(2),
  },
  globalDownloadsLoading: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: 1,
    overflow: 'auto',
  },
  button: {
    ...theme.palette.button,
    margin: theme.spacing(1),
    justifyContent: 'space-evenly',
  },
  buttonContainer: {
    ...theme.palette.mapInfoSection,
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
  },
  label: {
    display: 'flex',
    flex: '1 1 auto',
    justifyContent: 'center',
  },
}));

export const GlobalDownloadsPage = () => {
  const classes = useStyles();
  const setOpen = downloadHistoryStore.use.setOpen();
  const { setSnack } = useContext(SnackbarContext);
  const { createGlobalDownload, data, loading, error } = useGlobalDownloads();

  useEffect(() => {
    if (data?.createGlobalDownload) {
      setSnack({
        open: true,
        message: 'Your global download request has been received.',
        severity: 'success',
      });
      setOpen(true);
    }
    if (error?.message) {
      setSnack({
        open: true,
        message: error.message || "We're sorry, but something went wrong.",
        severity: 'error',
      });
    }
  }, [data, error, setSnack, setOpen]);

  return (
    <Grid container className={classes.root}>
      <Grid container direction='column' spacing={2} className={classes.globalDownloadsDescription}>
        <Grid>
          <Typography variant='body1' component='p'>
            Access comprehensive Welligence data through a single Excel download. Our complete
            dataset export enables you to analyze, manipulate, and integrate the information into
            your existing workflows and systems beyond the Welligence platform.
          </Typography>
        </Grid>
        <Grid container direction='row' spacing={2} className={classes.buttonContainer}>
          <Grid>
            <Tooltip title='Field Summary by Company' aria-label='field summary by company'>
              <Button
                className={classes.button}
                variant='contained'
                onClick={() =>
                  createGlobalDownload({ downloadType: DownloadTypeEnum.FieldSummaryByCompany })
                }
                disabled={loading}
              >
                <GetAppIcon fontSize='small' color='primary' />
                <div className={classes.label}>Field Summary By Company</div>
              </Button>
            </Tooltip>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
